const baseCommon =
  typeof window !== 'undefined' && window.feConfig && window.feConfig.common;
const staticBaseUrl =
  (baseCommon && window.feConfig.common.staticBaseUrl) ||
  'https://stc.yxt.com/';

// 展示内容字典键
export const dictionaryKeys = {
  user: 'user', // 学员
  userName: 'fullname', // 姓名
  userImgUrl: 'userImgUrl', // 头像
  deptName: 'deptName', // 部门名称
  deptImg: 'deptImg', // 部门图标
  orgName: 'orgName' // 平台名称
};

// 参与对象 对应的排行榜上第二列文案
export const objectName = {
  user: 'pc_biz_rank_user', // 学员
  deptAvg: 'pc_biz_rank_dept', // 部门
  deptSum: 'pc_biz_rank_dept' // 部门
};

// 参与对象 对应的排行榜无数据时文案
export const emptyTip = {
  user: 'pc_biz_rank_user_empty_tip', // 暂无人员上榜
  deptAvg: 'pc_biz_rank_dept_empty_tip', // 暂无部门上榜
  deptSum: 'pc_biz_rank_dept_empty_tip' // 暂无部门上榜
};

// 参与对象 对应的排行榜上第一优先级的显示内容
export const primaryCode = {
  user: dictionaryKeys.userName,
  deptAvg: dictionaryKeys.deptName,
  deptSum: dictionaryKeys.deptName
};

// 排行维度 对应的排行榜上第三列文案
export const attributeName = {
  user: {
    integral: 'pc_biz_rank_integral', // 积分
    credits: 'pc_biz_rank_studyscore', // 学分
    exp: 'pc_biz_rank_exp', // 经验值
    learningTime: 'pc_biz_rank_studyTime' // 学习时长
  },
  deptAvg: {
    integral: 'pc_biz_rank_per_integral', // 人均积分'),
    credits: 'pc_biz_rank_per_studyscore', // 人均学分
    exp: 'pc_biz_rank_per_exp', // 人均经验值
    learningTime: 'pc_biz_rank_per_studyTime' // 人均学习时长
  },
  deptSum: {
    integral: 'pc_biz_rank_total_integral', // 总计积分
    credits: 'pc_biz_rank_total_studyscore', // 总计学分
    exp: 'pc_biz_rank_total_exp', // 总计经验值
    learningTime: 'pc_biz_rank_total_studyTime' // 总计学习时长
  }
};

// 排行维度 对应的排行榜上的榜单名称
export const rankName = {
  integral: 'pc_biz_rank_integral_rank', // 积分榜
  credits: 'pc_biz_rank_studyscore_rank', // 学分榜
  exp: 'pc_biz_rank_exp_rank', // 经验值榜
  learningTime: 'pc_biz_rank_studyTime_rank' // 学习时长榜
};

export const sspSvgCdn = `${staticBaseUrl}ufd/55a3e0/ssp/pc/svg/`;

export const sspImgCdn = `${staticBaseUrl}ufd/55a3e0/ssp/pc/img/`;

// 跳转用户中心
export const linkToUserIndex = userId => {
  if (userId) {
    window.open(
      `${window.location.protocol}//${window.location.host}/#/userindex?userId=${userId}`
    );
  }
};

// 格式化榜单数据 -- 保留两位小数，最大展示到千万级，示例：99,999,999.99
export const numberUnit = value => {
  value = value ? Number(value) : 0; // 当前值
  const minus = value < 0 ? '-' : '';
  value = Math.abs(value);
  const decimals = 2; // 保留两位小数
  if (value === 0) return value;
  const overflowValue = 100000000; // 当数值大于等于1亿，则千位前数值显示为k+  示例：999,999k+
  const over = value >= overflowValue ? 'k+' : '';
  if (value >= overflowValue) {
    value = (value + '').split('.')[0].slice(0, -3);
  } else {
    const arr = (value + '').split('.');
    value = arr[0] + (arr[1] ? '.' + (arr[1] + '').slice(0, decimals) : '');
  }
  // toLocaleString 实现千分位分隔
  return minus + Number(value).toLocaleString() + over;
};

// 横排式 前三名的各类图片
export const horizontalHeadImgs = [
  {
    bg: 'rank_silver_bg.png', // 第二名
    crown: 'rank_silver_crown.png',
    order: 1
  },
  {
    bg: 'rank_golden_bg.png', // 第一名 背景图
    crown: 'rank_golden_crown.png', // 皇冠
    order: 0 // 名次
  },
  {
    bg: 'rank_copper_bg.png', // 第三名
    crown: 'rank_copper_crown.png',
    order: 2
  }
];

// 时间范围的各类选项
export const dateList = [
  {
    label: 'pc_biz_rank_total_time',
    text: '全部时间',
    type: 1,
    tip: 'pc_biz_rank_total_time_tip',
    tipText: '数据统计截止昨日',
    order: 1
  },
  {
    label: 'pc_biz_rank_this_year',
    text: '本年',
    type: 2,
    tip: 'pc_biz_rank_this_year_tip',
    tipText: '数据统计截止昨日，1月1号查看去年排行',
    order: 2
  },
  {
    label: 'pc_biz_rank_this_quarter',
    text: '本季度',
    type: 5,
    tip: 'pc_biz_rank_this_quarter_tip',
    tipText: '数据统计截止昨日，每季度首日查看上季度排行',
    order: 3
  },
  {
    label: 'pc_biz_rank_this_month',
    text: '本月',
    type: 3,
    tip: 'pc_biz_rank_this_month_tip',
    tipText: '数据统计截止昨日，每月1号查看上月排行',
    order: 4
  },
  {
    label: 'pc_biz_rank_this_week',
    text: '本周',
    type: 4,
    tip: 'pc_biz_rank_this_week_tip',
    tipText: '数据统计截止昨日，每周一查看上周排行',
    order: 5
  }
];
